<template>
  <div v-if="chips.length" class="quickLinks" :class="{ compact }">
    <a
      v-for="chip in chips"
      :key="chip.key"
      class="qlink"
      :class="{ compact }"
      :href="chip.href"
      target="_blank"
      rel="noopener"
      :title="`Open in ${chip.label}`"
      @click.stop
    >
      <FavIcon :domain="chip.domain" :size="compact ? 15 : 16" />
      <span v-if="!compact" class="qlLabel">{{ chip.label }}</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import FavIcon from '../../../components/FavIcon.vue'
import { buildCrmChips, preloadCrmLinkConfig } from '../../../services/crmLinks'
import type { CallerQueueCrmIds } from '../../../services/dialerApi'

const props = defineProps<{ crmIds: CallerQueueCrmIds | null; compact?: boolean }>()

const ready = ref(false)
onMounted(async () => {
  await preloadCrmLinkConfig()
  ready.value = true
})
const chips = computed(() => {
  void ready.value
  return buildCrmChips(props.crmIds)
})
</script>

<style scoped>
.quickLinks { display: flex; flex-wrap: wrap; gap: var(--space-2); margin-top: var(--space-3); }
.qlink {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 30px;
  padding: 0 11px 0 6px;
  border-radius: var(--radius-md);
  background: var(--color-bg-subtle);
  text-decoration: none;
  transition: background var(--duration-fast) var(--ease-out);
}
.qlink:hover { background: var(--color-bg-sunk); }
.qlLabel { font-size: var(--fs-xs); font-weight: var(--fw-medium); color: var(--color-text-secondary); }

/* Compact = logos only (used inline in front of a name, e.g. the dialer history row). */
.quickLinks.compact { margin-top: 0; gap: 4px; flex-wrap: nowrap; }
.qlink.compact { height: auto; padding: 2px; background: transparent; gap: 0; border-radius: 5px; }
.qlink.compact:hover { background: var(--color-bg-subtle); }
</style>
